import { getCurrentInstance } from 'vue';
import { mapGetters } from 'vuex';

import useMembershipPromotion from '@/composables/use-membership-promotion';
import { formatMoney } from '@/helpers/format';

export default {
  computed: {
    ...mapGetters('subscriptionPlans', [
      'getYearlySubscriptionPlan',
      'hasPromotion',
    ]),

    annualAmount() {
      return this.subscriptionPromotion.annualPrice.amount;
    },

    currency() {
      return this.price?.currency;
    },

    formattedAnnualAmount() {
      return this.formatAmountWithCurrency(this.annualAmount);
    },

    formattedMonthlyAmount() {
      return this.formatAmountWithCurrency(this.monthlyAmount);
    },

    formattedOriginalAnnualAmount() {
      return this.formatAmountWithCurrency(this.originalAnnualAmount);
    },

    formattedOriginalMonthlyAmount() {
      return this.formatAmountWithCurrency(this.originalMonthlyAmount);
    },

    isPromotionEnabled() {
      return this.promotion.isPromotionEnabled.value;
    },

    monthlyAmount() {
      return this.subscriptionPromotion.monthlyPrice.amount;
    },

    originalAnnualAmount() {
      return this.subscriptionPromotion?.originalAnnualPrice?.amount ?? 0;
    },

    originalMonthlyAmount() {
      return this.annualToMonthly(this.originalAnnualAmount);
    },

    plan() {
      return this.getYearlySubscriptionPlan ?? {};
    },

    planName() {
      return this.plan.product?.name;
    },

    price() {
      return this.plan.product?.price;
    },

    promotion() {
      const root = getCurrentInstance().proxy.$root;

      return useMembershipPromotion(root, this.plan);
    },

    subscriptionPromotion() {
      return this.promotion.promotion.value;
    },
  },

  methods: {
    annualToMonthly(price) {
      return Math.round((price / 12) * 100) / 100;
    },

    formatAmountWithCurrency(value) {
      const amount = formatMoney(value);
      const fractionDigits = amount % 1 === 0 ? 0 : 2;

      return this.$n(amount, {
        style: 'currency',
        currency: this.currency,
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits,
      });
    },
  },
};
